import { render } from "./AcceptKEN.vue?vue&type=template&id=f0cea086"
import script from "./AcceptKEN.vue?vue&type=script&lang=js"
export * from "./AcceptKEN.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__